import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class CancelApiService {

  private cancelRequests$ = new Subject<void>();

  get cancelObservable$() {
    return this.cancelRequests$.asObservable();
  }

  cancelAllRequests(): void {
    this.cancelRequests$.next(); // Emit a value to cancel all requests
  }

}
